import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import type { TeslaRoadsterQualityId } from "./tesla-roadster-preset";

export interface TeslaRoadsterShowcaseClip {
	id: string;
	quality: TeslaRoadsterQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages: string[];
}

const R2_BASE = "home/showcase/tesla-roadster-car";
/** External Kavel examples, captured 2026-10-27; not outputs from our 10-second preset. */
const SPECS = [
	{ id: "downtown", duration: 12.256 },
	{ id: "motorway", duration: 12.256 },
	{ id: "sunset", duration: 12.256 },
];
export const teslaRoadsterShowcaseClips: TeslaRoadsterShowcaseClip[] =
	SPECS.map((clip) => ({
		id: clip.id,
		quality: "hd",
		orientation: "portrait",
		onSite: false,
		duration: clip.duration,
		videoUrl: buildR2AssetsImageUrl(`${R2_BASE}/clips/${clip.id}-720p.mp4`),
		previewVideoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/${clip.id}-720p.mp4`,
		),
		poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/${clip.id}-720p.jpg`),
		hasAudio: true,
		inputImages: [],
	}));
export const TESLA_ROADSTER_SHOWCASE_UPLOADED_AT = "2026-10-27T00:00:00+08:00";
